import { CCPersonOrganizationMembership } from '@heidelberg/control-center-frontend-integration/cc';

export function findMembership(
    orgId: string,
    organizationMemberships: CCPersonOrganizationMembership[]
): CCPersonOrganizationMembership | undefined {
    return organizationMemberships.find((m) => m.organization.id === orgId);
}
